<template>
  <div id="app">
    <v-app :class="color">
      <header-app></header-app>
      <menunav-app :linksPath="linksPath"></menunav-app>
      <accesmen-app></accesmen-app>
      <main tabindex="-1">
        <section class="main-container">
          <v-layout justify-center wrap class="appcontain">
            <v-flex xs12 sm12 md12 lg12 >
              <router-view></router-view>
            </v-flex>
          </v-layout>
        </section>
      </main>
      <footer-app></footer-app>
      <button class="offscreen" @click="ir_a_region_principal">Volver a la región principal</button>
    </v-app>
  </div>
</template>

<script>
export default {
  name: "app",
  methods:{
    ir_a_region_principal(){
      document.getElementsByTagName("main")[0].focus()
    }
  },
  computed: {
    color() {
      return this.$store.state.color;
    },
    linksPath(){
      return this.$store.state.linksPath;
    }
  }
};
</script>

<style src="./sass/styles.scss" lang="scss">

</style>



// WEBPACK FOOTER //
// App.vue?6dc741a8